import React, {useEffect, useState} from "react";
import {getCurrentUser, disconnect, getUserFromUid} from "../class/User";

export default function Menu(props) {

    const [uid, setUid] = useState();
    const [loading, setLoading] = useState(true);
    const [dossiers, setDossiers] = useState(0);
    useEffect(() => {

        const getData = async () => {
            try {
                let user = await getCurrentUser();
                if (user) {
                    let societe = await getUserFromUid(user.uid);
                    if (societe?.affiliation_user) {
                        let affilie = await getUserFromUid(societe.affiliation_user);
                        if (affilie) {
                            setDossiers(affilie.dossier);
                        }
                    } else {
                        setDossiers(societe.dossier);
                    }
                    if (user) {
                        setUid(user.uid);
                    }
                }
                setLoading(false);
            } catch (error) {
                console.log("Hors ligne Users");
            }
        };
        getData();

    }, []);

    const deconnexion = () => {
        disconnect();
    }


    return (
        <header className={"header-menu"}>
            <nav className="navbar navbar-expand-xxl">
                <div className="container-fluid">
                    <div className={"d-flex flex-column"}>
                        <a href="https://facturesimpayees.com"
                           className="navbar-brand d-flex align-items-center text-dark text-decoration-none logo mx-0">
                            <img src={"/assets/img/logo.png"} alt={"Logo factures impayées"} width={44} height={60}/>
                            <span className="texte-logo">Facturesimpayees.com<span
                                className={"version"}></span></span>
                            {props.dashboard ?
                                <div className={"dashboard ml-3 pt-3 d-xl-flex d-none"}>Dashboard</div> : null}
                        </a>

                        {uid && dossiers ?
                            <div className={"credits d-flex"}><img src={"/assets/img/credits.png"} width={"15"}
                                                                   height={"15"} alt={"crédits"}
                                                                   className={"icone-credits me-2"}/> Crédit{dossiers > 1 ? "s" : ""}
                                : {dossiers}
                                &nbsp;dossier(s)</div> : null}
                    </div>
                    {loading ? null :
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarsMain" aria-controls="navbarsMain" aria-expanded="false"
                                aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>}

                    <div className="collapse navbar-collapse justify-content-end" id="navbarsMain">
                        <ul className="nav nav-pills navbar-nav align-items-center menu-principal gap-xxl-2 gap-0">
                            {/*<li className="nav-item order-last order-xxl-first li-rechercher"><input
                                    type="search"
                                    placeholder="Rechercher"
                                    className="rechercher"/></li>*/}
                            {/*<li className="nav-item"><a href="/#solution" className="nav-link element-menu"
                                                        aria-current="page">La
                                solution</a></li>*/}
                            {/*<li className="nav-item dropdown">
                                <a href="/#fonctionnalites" className="nav-link element-menu" id="dropdown01"
                                >Fonctionnalités</a>
                                <ul className="dropdown-menu dropdown-menu-style" aria-labelledby="dropdown01">
                                        <li><a className="dropdown-item element-sous-menu" href="/">Scannez les
                                            documents
                                            avec votre téléphone</a></li>
                                        <li><a className="dropdown-item element-sous-menu" href="/">L'intelligence
                                            artificielle pour lire vos factures</a></li>
                                        <li><a className="dropdown-item element-sous-menu" href="/">Transmission
                                            direct
                                            au
                                            tribunal compétent</a></li>
                                    </ul>
                            </li>*/}
                            <li className="nav-item"><a href="https://facturesimpayees.com/#tarifs"
                                                        className="nav-link element-menu">Les Tarifs</a>
                            </li>
                            <li className="nav-item"><a href="https://facturesimpayees.com/actualites/"
                                                        className="nav-link element-menu">Actualités</a>
                            </li>
                            <li className="nav-item"><a href="https://facturesimpayees.com/contact"
                                                        className="nav-link element-menu">Contactez-nous</a>
                            </li>
                            <li className="nav-item"><a href="https://facturesimpayees.com/#faq"
                                                        className="nav-link element-menu">FAQ</a></li>
                        </ul>
                        {!loading ?
                            <ul className="nav nav-pills navbar-nav align-items-center menu-principal gap-xxl-2 gap-0">
                                {uid ?
                                    <li className="nav-item mise-en-avant align-items-center d-flex justify-content-center">
                                        <a
                                            href="/dashboard" className="nav-link element-menu">Tableau de bord</a>
                                    </li> :
                                    <li className="nav-item mise-en-avant align-items-center d-flex justify-content-center">
                                        <a
                                            href="/inscription" className="nav-link element-menu">Inscription</a>
                                    </li>}
                                {uid ? <li className="nav-item"><a onClick={deconnexion} href="/"
                                                                   className="nav-link element-menu">Déconnexion</a>
                                </li> : <li className="nav-item"><a href="/connexion"
                                                                    className="nav-link element-menu">Connexion</a>
                                </li>}
                            </ul> : null}
                    </div>
                </div>
            </nav>
            {props.children}
        </header>
    );
}
